// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"collage"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M3 3L3 21H9L11 12L13 3L3 3Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M21 3L13 3L9 21L21 21L21 3Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M13 3L3 3L3 21H9M13 3L21 3L21 16M13 3L11 12M9 21L21 21V16M9 21L11 12M21 16L11 12","strokeWidth":"props.strokeWidth"}}]}]};

const CollageIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'collage',
    ref,
    icon: element,
  },
));

CollageIcon.displayName = 'CollageIcon';

export default CollageIcon;
